/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseListSystemExchangeRateRespVo,
  ResponseLong,
  ResponsePageDataSystemExchangeRateRespVo,
  ResponseRateEchoRespVo,
  SystemExchangeRateUpdateReqVo,
} from '../models/index';
import {
    ResponseListSystemExchangeRateRespVoFromJSON,
    ResponseListSystemExchangeRateRespVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataSystemExchangeRateRespVoFromJSON,
    ResponsePageDataSystemExchangeRateRespVoToJSON,
    ResponseRateEchoRespVoFromJSON,
    ResponseRateEchoRespVoToJSON,
    SystemExchangeRateUpdateReqVoFromJSON,
    SystemExchangeRateUpdateReqVoToJSON,
} from '../models/index';

export interface SystemExchangeRateHistoryGetRequest {
    currentPage: number;
    pageSize: number;
    rateType: number;
}

export interface SystemExchangeRatePostRequest {
    systemExchangeRateUpdateReqVo?: SystemExchangeRateUpdateReqVo;
}

/**
 * 
 */
export class USDTTSystemExchangeRateControllerApi extends runtime.BaseAPI {

    /**
     * 查询所有类型当前生效的汇率（顶部当前值展示） 当前生效汇率列表 查询所有类型当前生效的汇率（USD、电汇TT）
     * 当前生效汇率列表
     */
    async systemExchangeRateCurrentGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListSystemExchangeRateRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system-exchange-rate/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListSystemExchangeRateRespVoFromJSON(jsonValue));
    }

    /**
     * 查询所有类型当前生效的汇率（顶部当前值展示） 当前生效汇率列表 查询所有类型当前生效的汇率（USD、电汇TT）
     * 当前生效汇率列表
     */
    async systemExchangeRateCurrentGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListSystemExchangeRateRespVo> {
        const response = await this.systemExchangeRateCurrentGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 汇率回显（中国当前生效汇率 + 韩国当前生效汇率 + 电汇TT当前生效汇率） 汇率回显 返回中国当前生效汇率(rate表)、韩国当前生效汇率(rate表)与电汇TT当前生效汇率(system_exchange_rate表rateType=2)，供前端回显
     * 汇率回显
     */
    async systemExchangeRateEchoGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseRateEchoRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system-exchange-rate/echo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseRateEchoRespVoFromJSON(jsonValue));
    }

    /**
     * 汇率回显（中国当前生效汇率 + 韩国当前生效汇率 + 电汇TT当前生效汇率） 汇率回显 返回中国当前生效汇率(rate表)、韩国当前生效汇率(rate表)与电汇TT当前生效汇率(system_exchange_rate表rateType=2)，供前端回显
     * 汇率回显
     */
    async systemExchangeRateEchoGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseRateEchoRespVo> {
        const response = await this.systemExchangeRateEchoGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 分页查询指定类型的历史记录 汇率历史记录(分页) 分页查询指定类型汇率的历史记录
     * 汇率历史记录(分页)
     */
    async systemExchangeRateHistoryGetRaw(requestParameters: SystemExchangeRateHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataSystemExchangeRateRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling systemExchangeRateHistoryGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling systemExchangeRateHistoryGet().'
            );
        }

        if (requestParameters['rateType'] == null) {
            throw new runtime.RequiredError(
                'rateType',
                'Required parameter "rateType" was null or undefined when calling systemExchangeRateHistoryGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['rateType'] != null) {
            queryParameters['rateType'] = requestParameters['rateType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system-exchange-rate/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataSystemExchangeRateRespVoFromJSON(jsonValue));
    }

    /**
     * 分页查询指定类型的历史记录 汇率历史记录(分页) 分页查询指定类型汇率的历史记录
     * 汇率历史记录(分页)
     */
    async systemExchangeRateHistoryGet(requestParameters: SystemExchangeRateHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataSystemExchangeRateRespVo> {
        const response = await this.systemExchangeRateHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 更新汇率（关闭旧生效行 + 插入新生效行，保留历史） 更新汇率 更新指定类型汇率：关闭旧生效行并插入新生效行，保留历史记录
     * 更新汇率
     */
    async systemExchangeRatePostRaw(requestParameters: SystemExchangeRatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system-exchange-rate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SystemExchangeRateUpdateReqVoToJSON(requestParameters['systemExchangeRateUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 更新汇率（关闭旧生效行 + 插入新生效行，保留历史） 更新汇率 更新指定类型汇率：关闭旧生效行并插入新生效行，保留历史记录
     * 更新汇率
     */
    async systemExchangeRatePost(requestParameters: SystemExchangeRatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.systemExchangeRatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
